import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DictionaryContractType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'contracts-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
  standalone: false,
})
export class ContractListViewComponent {
  @Input() contracts: app.models.ContractModel[] = [];
  @Input() props: app.models.DynamicPropsDictionary;
  @Output() viewDetails: EventEmitter<string> = new EventEmitter<string>();

  ContractType = DictionaryContractType;

  constructor() {}

  viewDetailsHandler(id: string) {
    this.viewDetails.emit(id);
  }
}
